import React from 'react';
import { Modal } from 'antd';
import './index.scss';

interface IProps {
  url: string;
  title?: string;
  onCancel: () => void
}
interface IState {}


class MediaPlayer extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }
    audioRef = React.createRef<HTMLAudioElement>();

    componentWillUnmount(): void {
        this.audioRef.current && this.audioRef.current.pause();
    }

    handleCancel = () => {
      this.props.onCancel();
    };

    render(): React.ReactNode {
        const { url, title = '播放' } = this.props;
        return (
            <Modal
                title={title}
                visible={true}
                footer={null}
                onCancel={this.handleCancel}
                width="500px"
            >
                <div className="media-modal">
                    <audio controls src={url} ref={this.audioRef}>
                        你的浏览器不支持当前资源或者当前资源有问题，请下载下来查看
                    </audio>
                </div>
            </Modal>
        );
    }
}

export default MediaPlayer;
